import { CuttingToolType } from "@enums/cuttingToolType.enum";

// Machine production statuses as the toolroom shows them - the same words and colours as the operator terminal.
export function ToolroomMachineStatus(status?: number): { label: string; tone: string } {
	switch (status) {
		case 10: return { label: "Running", tone: "go" };
		case 50: return { label: "Setting up", tone: "setup" };
		case 90: return { label: "Inspection", tone: "info" };
		case 80: return { label: "Q loop", tone: "info" };
		case 20: return { label: "Not running", tone: "idle" };
		case 40: return { label: "Inactive", tone: "idle" };
		case 70: return { label: "Break", tone: "warn" };
		case 60: return { label: "Toilet break", tone: "warn" };
		case 130: return { label: "Tip change", tone: "warn" };
		case 140: return { label: "Swarf clean out", tone: "warn" };
		case 30: return { label: "Maintenance", tone: "danger" };
		case 110: return { label: "Initial check failed", tone: "danger" };
		case 120: return { label: "Breakdown", tone: "danger" };
		case 100: return { label: "Supervisor requested", tone: "alert" };
		default: return { label: "No status", tone: "idle" };
	}
}

// Tool images are stored as a JSON array of { fileUrl }.
export function ToolroomFirstImage(imageUrls?: string): string {
	try {
		const images = JSON.parse(imageUrls || "[]");
		return (Array.isArray(images) ? images : []).find((i: any) => i?.fileUrl)?.fileUrl || "";
	} catch (e) {
		return "";
	}
}

export function ToolroomMinutes(total?: number | null): string {
	if (!total || total < 0.5) return "";
	const h = Math.floor(total / 60);
	const m = Math.round(total % 60);
	return h ? `${h}h ${m}m` : `${m}m`;
}

// A cutter's type as words, from the enum, so a new type needs adding in one place only.
export function ToolroomCutterType(type?: number | null): string {
	if (type === null || type === undefined) return "";
	return CuttingToolType[type] ? CuttingToolType[type].replace(/(\B[A-Z])/g, " $1") : "";
}

// "T4 Ø12 Carbide Drill" - what the boards and the planner label a cutter with.
export function ToolroomCutterLabel(cutter?: { diameter?: string; toolNumber?: string; toolType?: number } | null): string {
	if (cutter == null) return "";
	return `${cutter.toolNumber || "Tool"}${cutter.diameter ? ` Ø${cutter.diameter}` : ""} ${ToolroomCutterType(cutter.toolType)}`.trim();
}
